// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"727d4560","246":"26d3c906","290":"6107ab35","415":"236f695f","512":"2d1fd0d6","649":"3eab1240","966":"03b80877"}[chunkId] + ".chunk.js";
};